export default {
    namespaced: true,

    state: {
        object: {},
        singular_name: '',
        plural_name: '',
        routes: {
            'update': '',
            'delete': '',
            'restore': '',
        },
    },

    getters: {
        get(state) {
            return state.object;
        },
        getName(state) {
            return state.singular_name;
        },
        getSingularName(state) {
            return state.singular_name;
        },
        getPluralName(state) {
            return state.plural_name;
        },
    },

    actions: {
        initialize(context, data) {
            return new Promise((resolve, reject) => {
                if (!data) {
                    reject('Incorrect data for object initialization.');
                }

                if (
                    typeof data.singular_name == 'undefined' ||
                    (typeof data.singular_name !== 'undefined' && !data.singular_name)
                ) {
                    reject('Singular name required for object initialization.');
                }

                if (
                    typeof data.plural_name == 'undefined' ||
                    (typeof data.plural_name !== 'undefined' && !data.plural_name)
                ) {
                    reject('Plural name required for object initialization.');
                }

                if (
                    typeof data.object == 'undefined' ||
                    (typeof data.object !== 'undefined' && !data.plural_name)
                ) {
                    reject('Plural name required for object initialization.');
                }

                if (typeof data.routes == 'undefined') {
                    data.routes = {};
                }

                context.commit('setData', {
                    'key': 'singular_name',
                    'data': data.singular_name
                });
                context.commit('setData', {
                    'key': 'plural_name',
                    'data': data.plural_name
                });
                context.commit('setData', {
                    'key': 'routes',
                    'data': data.routes
                });
                context.commit('setData', {
                    'key': 'object',
                    'data': data.object
                });

                resolve();
            });
        },
        update(context) {
            return new Promise((resolve, reject) => {
                let url = '/' + context.state.plural_name + '/update';

                if (
                    typeof context.state.routes.update !== 'undefined'
                    && !context.state.routes.update
                ) {
                    url = context.state.routes.update;
                }

                let data = {};
                data[context.state.singular_name] = context.state.object;

                window.axios.post(url, data)
                    .then((response) => {
                        context.commit('setData', {
                            'key': 'object',
                            'data': response.data[context.state.singular_name]
                        });
                        resolve(response.data[context.state.singular_name]);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        delete() {

        },
        restore() {

        }
    },

    mutations: {
        setData(state, object) {
            state[object.key] = object.data;
        },
    }
}
